<template>
	<div class="modal-wrapper new-wizard-modal-wrapper">
		<div class="warning-container">
			<div class="warning-modal-title">
				{{ title }}
			</div>
			<div class="warning-modal-body">
				{{ text }}
			</div>
			<continue-button :button-text="$tc('modals.wizardSportCameraInfo.okButton')" @click="onConfirm" />
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import { capitalize } from '~/assets/util/helpers'
import ContinueButton from '~/components/wizard-new/common/ContinueButton'

export default {
	name: 'ModalWizardRenew',
	components: {
		ContinueButton
	},
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	computed: {
		cameraType () {
			return this.options.camera && this.options.camera.metadata && capitalize(this.options.camera.metadata.cameraType)
		},
		title () {
			return this.cameraType === 'Action' ? this.$tc('modals.wizardRenew.titleImportant') : this.$tc('modals.wizardRenew.title')
		},
		text () {
			const airOwnText = `${this.$tc('modals.wizardRenew.mainText[0]')} ${this.cameraType} ${this.$tc('modals.wizardRenew.mainText[1]')} ${this.cameraType} ${this.$tc('modals.wizardRenew.mainText[2]')}`
			return this.cameraType === 'Action' ? this.$tc('modals.wizardRenew.goProText') : airOwnText
		}
	}
}
</script>

<style lang="scss">
.new-wizard-modal-wrapper {
	font-size: 20px;
	line-height: 28px;
	.warning-container {
		color: #2B2B2B;
		box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.11);
		border-radius: 20px;
		border: none;
		max-width: 410px;
		width: calc(100% - 40px);
		height: auto;
		padding: 41px 29px 28px;
		background: #fff;
		gap: 15px;
		.warning-modal-title {
			font-size: 24px;
			line-height: 28px;
			font-weight: 500;
			margin: 0;
		}
		.warning-modal-body {
			font-size: 16px;
			line-height: 26px;
		}
	}
}
</style>
